import React from "react";
import Skeleton from "@mui/material/Skeleton";

export default function AssigneeSkeleton() {
  return (
    // <div className="dashboard-cards-container" style={{ gridTemplateColumns: "1fr 1fr 1fr 1fr" }}>
      <Skeleton variant="circular" width={21} height={21} />
    // </div>
  );
}